export const EMPTY_RESPONSE_ERROR_NAME = 'EMPTY_RESPONSE_ERROR_NAME';

export class EmptyResponseError extends Error {
  public readonly name: string = EMPTY_RESPONSE_ERROR_NAME;

  constructor(methodName: string, public response?: any) {
    super(`Emprty response for: ${methodName}`);
  }
}
